import classNames from 'classnames';
import React from 'react';
import { ReactComponent as CloudImg } from 'assets/images/cloud.svg';

import RouterLinkButton from 'components/UI_kit_3/Button/RouterLinkButton';
import { useTranslation } from 'react-i18next';
import LinkButton from 'components/UI_kit_3/Button/LinkButton';
import { ReactComponent as PlusIcon } from 'assets/icons_3/plus.svg';
import { ReactComponent as NoDataIcon } from 'assets/icons_3/file-x-03.svg';
import Button from 'components/UI_kit_3/Button/Button';
import { LinkProps } from 'react-router-dom';
import styles from './ServiceNoData.module.scss';

type ServiceNoDataLink = {
  path?: string
  title: string
  state?: LinkProps['state']
  external?: boolean
  onClick?: () => void
  disabled?: boolean
  qaElement?: string
};
export interface ServiceNoDataProps {
  className?: string;
  icon?: React.ReactNode;
  title?: string;
  descriptions?: string[] | React.ReactNode;
  hideButton?: boolean;
  iconButton?:React.ReactNode;
  link?: ServiceNoDataLink;
  links?: Array<ServiceNoDataLink>
  size?: 'sm' | 'md'
  variant?: 'card' | 'default'
}

const ServiceNoData: React.FC<ServiceNoDataProps> = ({
  icon,
  title,
  descriptions = [],
  hideButton = false,
  iconButton,
  link,
  links = [],
  size = 'md',
  variant = 'default',
  className,
}) => {
  const [t] = useTranslation();

  return (
    <div className={classNames(styles.noDataBg, styles[size], styles[variant], className)}>
      <div className={styles.noDataBgContent}>
        <div className={styles.cloud}>
          <CloudImg />
          <div className={styles.serviceIcon}>{icon || <NoDataIcon />}</div>
        </div>
        <h2 className={styles.title}>{title || t('table.no_data')}</h2>
        {descriptions && (
          Array.isArray(descriptions)
            ? descriptions.map((text, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <p key={index} className={styles.description}>{text}</p>
            ))
            : <div>{ descriptions }</div>
        )}
        {links.length > 0 && (
        <div className={styles.links}>
          {links.map((_link) => (_link.external
            ? <LinkButton variant="link-underline" key={_link.path} href={_link.path} qa-element={_link.qaElement}>{_link.title}</LinkButton>
            : <RouterLinkButton variant="link-underline" key={_link.path} to={_link.path || ''} qa-element={_link.qaElement} state={_link.state}>{_link.title}</RouterLinkButton>))}
        </div>
        )}
        {!hideButton && link?.path && !link.external && (
        <RouterLinkButton
          className="mt-2xl mb-2xl"
          prefixIcon={iconButton || <PlusIcon />}
          to={link.path}
          disabled={link?.disabled}
          qa-element={link?.qaElement}
          state={link.state}
        >
          {link.title || t('common.create')}
        </RouterLinkButton>
        )}
        {!hideButton && link?.onClick && (
        <Button
          className="mt-2xl mb-2xl"
          prefixIcon={iconButton || <PlusIcon />}
          onClick={() => link.onClick?.()}
          disabled={link?.disabled}
          qa-element={link?.qaElement}
        >
          {link.title || t('common.create')}
        </Button>
        )}
      </div>
    </div>
  );
};
export default ServiceNoData;
